export default {
  ANNOUNCEMENT_CLOSE: 'ANNOUNCEMENT_CLOSE',
  ANNOUNCEMENT_EXPAND: 'ANNOUNCEMENT_EXPAND',
};
